import ConversationApi from '../../api/inbox/conversation';

// Fila de espera (pílula da tela de chat).
// - waitingCount / oldestWaitingSince: buscados no poll leve (queue_stats).
// - list: buscada só quando o popover abre (queue_list).
const state = {
  waitingCount: 0,
  oldestWaitingSince: null, // epoch (segundos) do 1º da fila
  list: [],
  uiFlags: {
    isFetchingList: false,
  },
};

export const getters = {
  getWaitingCount: $state => $state.waitingCount,
  getOldestWaitingSince: $state => $state.oldestWaitingSince,
  getQueueList: $state => $state.list,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetchStats: async ({ commit }, { inboxId } = {}) => {
    try {
      const { data } = await ConversationApi.queueStats({ inboxId });
      commit('SET_QUEUE_STATS', data);
    } catch (error) {
      // Silencioso: indicador não deve quebrar a tela de chat.
    }
  },
  fetchList: async ({ commit }, { inboxId } = {}) => {
    commit('SET_QUEUE_UI_FLAG', { isFetchingList: true });
    try {
      const { data } = await ConversationApi.queueList({ inboxId });
      commit('SET_QUEUE_LIST', data.payload || []);
    } catch (error) {
      commit('SET_QUEUE_LIST', []);
    } finally {
      commit('SET_QUEUE_UI_FLAG', { isFetchingList: false });
    }
  },
};

export const mutations = {
  SET_QUEUE_STATS($state, { waiting_count: count, oldest_waiting_since: since }) {
    $state.waitingCount = count || 0;
    $state.oldestWaitingSince = since || null;
  },
  SET_QUEUE_LIST($state, list) {
    $state.list = list;
  },
  SET_QUEUE_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
